import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LoadingStatus } from '../shared/loading';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { PraemienStatus, IPraemieStatus } from '../shared/praemie';
import { checkToTopButtonPosition } from '../shared/footer';
import { ActivatedRoute, Router } from '@angular/router';
import { GearsAnimationStatus } from '../shared/gearsanimation';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

  currentYear: number = new Date().getFullYear();
  loading: Observable<boolean> = this.loadingStatus.getLoadingStatus();
  praemie: Observable<IPraemieStatus> = this.praemienStatus.getPraemie();
  gearsAnimation: Observable<boolean> = this.gearsAnimationStatus.getGearsAnimation();

  constructor(private translateService: TranslateService, private loadingStatus: LoadingStatus, private praemienStatus: PraemienStatus,
    private route: ActivatedRoute, private router: Router, private gearsAnimationStatus: GearsAnimationStatus) {
    this.translateService.setDefaultLang('de');
    this.translateService.use('de');
  }

  ngOnInit(): void {
    this.removeQueryParameter();
    this.detectBrowser();
  }

  ngAfterViewInit(): void {
    const btnToTop = document.querySelector('.footer__totop');
    if (btnToTop) {
      window.addEventListener('scroll', function () {
        checkToTopButtonPosition(btnToTop);
      });
    }
  }

  removeQueryParameter(): void {
    this.route.queryParamMap.subscribe(params => {
      if (params.get('q')) {
        sessionStorage.setItem('q', params.get('q'));
        this.router.navigate([],
          { queryParams: { 'q': null }, queryParamsHandling: 'merge' });
      }
    });
  }

  detectBrowser(): void {
    if (this.isInternetExplorer()) {
      alert('Um alle Funktionen des HDI Rechners zu nutzen, steigen Sie bitte auf einen aktuellen Browser um - zum Beispiel Google Chrome, Firefox oder Microsoft Edge.');
      this.redirectToUrl('https://www.hdi.at/services/kontakt');
    }
  }

  isInternetExplorer() {
    const userAgent = window.navigator.userAgent;
    return /MSIE|Trident/.test(userAgent);
  }

  redirectToUrl(url: string): void {
    window.location.href = url;
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }
}
